import React from "react";
import "../styles/main.css";
import Navbar from "../components/Navbar";
import Ellipse from "../assets/Ellipse57.svg";
import "react-lazy-load-image-component/src/effects/opacity.css";
import VFBr_MP1 from "../assets/VFBr_MP1.jpg";
import VFBr_MP2 from "../assets/VFBr_MP2.jpg";
import VFBr_MP3 from "../assets/VFBr_MP3.jpg";
import { Link } from "react-router-dom";

const VFF_mainPage = () => {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden bg-black">
      <div className=" sm:relative sm:min-h-screen  flex-1 overflow-hidden bg-gradient-radial-30 bg-opacity-30 flex flex-col bg-no-repeat bg-center bg-cover transition-all duration-700">
        <Navbar />
        {/* Top Right Blob */}
        <div className="absolute top-[-10%] right-[0%] w-[700px] h-[700px] rounded-full opacity-40 blur-3xl pointer-events-none">
          <div
            className="absolute inset-0 rounded-full"
            style={{
              background:
                "radial-gradient(circle, rgba(255, 206, 0, 0.5) 10%, rgba(0, 160, 255, 0) 70%)",
            }}
          ></div>

          <img
            src={Ellipse}
            alt="Ellipse"
            className="absolute inset-0 w-full h-full object-contain"
          />
        </div>

        {/* Bottom Left Blob */}
        <div className="absolute bottom-[-15%] left-[-10%] w-[700px] h-[700px] rounded-full opacity-40 blur-3xl pointer-events-none">
          <div
            className="absolute inset-0 rounded-full"
            style={{
              background:
                "radial-gradient(circle, rgba(255, 206, 0, 0.5) 10%, rgba(0, 160, 255, 0) 70%)",
            }}
          ></div>

          <img
            src={Ellipse}
            alt="Ellipse"
            className="absolute inset-0 w-full h-full object-contain"
          />
        </div>

        {/* Content */}
        <div className="flex flex-col items-center justify-center flex-1 px-4 relative z-10 text-center pt-[130px] pb-12 sm:py-16">
          <h1
  style={{ fontFamily: "Norwester" }}
  className="sm:mt-6 text-[72px] xl:text-[56px] lg:text-[44px] md:text-[36px] sm:text-[30px] text-[#FFF528] mb-4 leading-tight"
>
  VUPOP FOR BRANDS
</h1>

<p className="font-Inter text-[32px] xl:text-[26px] lg:text-[22px] md:text-[20px] sm:text-[17px] font-[600] text-white mb-5 sm:mt-4 leading-snug">
  Activate Real Fans. Enrich Every Campaign.
</p>

<p className="font-Inter font-[400] text-[#ADADAD] max-w-5xl xl:max-w-4xl lg:max-w-3xl md:max-w-xl sm:max-w-full text-[18px] xl:text-[18px] lg:text-[16px] md:text-[15px] sm:text-[14px] mb-10 sm:mb-6 sm:px-4 leading-relaxed">
  Fans shape culture. They influence buying decisions, brand loyalty
  and community conversations. With Vupop, brands can engage real fans
  through authentic fan content, not only during sports events, but
  across marketing campaigns all year round
</p>

{/* Buttons */}
<div className="flex flex-wrap justify-center gap-4">
  <Link to="https://manager.vupop.io/broadcaster/signup/subscription" target="_blank">
    <button className="font-[Norwester] bg-[#FFF528]hover:bg-[#FFF528]/70 transition-colors text-black font-[400] uppercase rounded-lg tracking-wide
      text-[18px] xl:text-[16px] lg:text-[15px] md:text-[14px] sm:text-[14px]
      px-10 xl:px-8 sm:px-6 py-2.5 sm:py-2">
      Get Started
    </button>
  </Link>
</div>

{/* THREE IMAGES LAYOUT */}
<div className="mt-6 flex sm:flex-col md:flex-col lg:flex-row xl:flex-row flex-row xl:items-start lg:items-start sm:items-center justify-center gap-6 md:gap-6 lg:gap-8">
  {/* LEFT */}
  <div className="w-full sm:w-[280px] md:w-[360px] lg:w-[28%] xl:w-[26%]">
    <img
      src={VFBr_MP1}
      alt="Sports moment 1"
      className="w-full h-[240px] md:h-[260px] lg:h-[320px] xl:h-[380px] object-cover rounded-2xl shadow-xl"
    />
  </div>

  {/* CENTER */}
  <div className="w-full sm:w-[280px] md:w-[360px] lg:w-[32%] xl:w-[34%] sm:mt-0 md:mt-0 lg:mt-16 xl:mt-20">
    <img
      src={VFBr_MP2}
      alt="Sports moment 2"
      className="w-full h-[240px] md:h-[260px] lg:h-[380px] xl:h-[460px] object-cover rounded-2xl shadow-2xl"
    />
  </div>

  {/* RIGHT */}
  <div className="w-full sm:w-[280px] md:w-[360px] lg:w-[28%] xl:w-[26%]">
    <img
      src={VFBr_MP3}
      alt="Sports moment 3"
      className="w-full h-[240px] md:h-[260px] lg:h-[320px] xl:h-[380px] object-cover rounded-2xl shadow-xl"
    />
  </div>
</div>
        </div>
      </div>
    </div>
  );
};

export default VFF_mainPage;
